<usb-base-modal
  [title]="title"
  [subtitle]="subtitle"
  [message]="message"
  [confirmText]="confirmText"
  [cancelText]="cancelText"
  [showCancelButton]="showCancelButton"
  [size]="size"
  [titleReverse]="titleReverse"
  [icon]="icon"
>
  <!-- ng-content for additional content if needed -->
  <ng-content></ng-content>
</usb-base-modal>
